import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../components/helpers/IsEmpty";
import { Modal, Button, InputNumber, Input, DatePicker, Table } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import { renderColumns } from "./constants";
import { TiUser } from "react-icons/ti";
import Select from "react-select";
import QRCode from "react-qr-code";
import {
  AuthorizationList,
  CanAccess,
} from "../../components/template/authorization/Authorization";
import Swal from "sweetalert2";

const ListShelf = () => {
  const [id, setId] = useState();
  const [storageList, setStorageList] = useState([]);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [storageId, setStorageId] = useState();
  const [shelfName, setShelfName] = useState();
  const [shelfCode, setShelfCode] = useState();
  const [maxItem, setMaxItem] = useState();
  const [productCategoryId, setProductCategoryId] = useState();
  const [records, setRecords] = useState([]);
  const [totalRecord, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [modalAdd, setModalAdd] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);

  useEffect(() => {
    getData();
    getStorages();
    getProductCategories();
  }, []);

  const handleSubmit = (id = null, isDelete = false, name) => {
    setSubmitting(true);

    let data = {
      outlet_id:
        storageList.find((value) => value.value === storageId)?.outlet_id || 0,
      storage_id: storageId,
      name: shelfName,
      shelf_code: shelfCode,
      address:
        storageList.find((value) => value.value === storageId)?.address || "",
      product_category_id: productCategoryId,
      max_item: parseInt(maxItem),
    };

    if (IsEmpty(id)) {
      let url = `${process.env.REACT_APP_BASE_API_URL}shelf`;
      httpclient
        .POST(url, data)
        .then((response) => {
          setModalAdd(false);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}shelf/${id}`;
      if (isDelete === true) {
        Swal.fire({
          title: "Hapus Data",
          text: "Apakah anda yakin ingin menghapus shelf " + name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Hapus",
          cancelButtonText: "Batal",
        }).then((result) => {
          if (result.isConfirmed) {
            httpclient
              .DELETE(url)
              .then((response) => {
                SwalToast.fire({
                  icon: "success",
                  title: response.data.message,
                });
                getData();
              })
              .catch((error) => {
                if (error.response) {
                  console.log(error.response.data.error);
                  SwalToast.fire({
                    icon: "error",
                    title: error.response.data.error.message,
                  });
                } else {
                  console.log(error);
                  SwalToast.fire({
                    icon: "error",
                    title: "Whoops, something went wrong",
                  });
                }
              })
              .finally(() => {
                setSubmitting(false);
              });
          }
        });
      } else {
        httpclient
          .PUT(url, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            window.location.reload(false);
          })
          .catch((error) => {
            if (error.response) {
              setModalAdd(false);
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const handleEdit = (record) => {
    console.log(record);
    setModalAdd(true);
    setStorageId(record.storage_id);
    setShelfName(record.name);
    setShelfCode(record.shelf_code);
    setMaxItem(record.max_item);
    setProductCategoryId(record.product_category_id);
    setId(record.id);
    setIsEdit(true);
  };

  const handleDelete = (record) => {
    handleSubmit(record.id, true, record.name);
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setStorageId(0);
    setShelfName("");
    setShelfCode("");
    setMaxItem("");
    setProductCategoryId(0);
    setId("");
  };

  const getData = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}shelf?name=${search}&page=${page}&size=${pageSize}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        console.log(response);

        let data = [];
        response.data.data.items.forEach((value) => {
          data.push({
            ...value,
            is_checked: false,
          });
        });
        setRecords(data);
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getStorages = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}storage`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setStorageList(
          response.data.data.items.map((item) => ({
            value: item.id,
            label: item.name,
            ...item,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };
  const getProductCategories = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setProductCategoryList(
          response.data.data.items.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const searchData = (name) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearch(name);
    setSearchTimeout(
      setTimeout(function () {
        getData();
      }, 700)
    );
  };

  const onCheck = (record) => {
    let temp = [...records];
    temp.find((value) => value.id === record.id).is_checked = !temp.find(
      (value) => value.id === record.id
    ).is_checked;
    setRecords(temp);
  };
  const onCheckAll = () => {
    setCheckAll(!checkAll);
    let temp = [...records];
    temp.forEach((value) => {
      value.is_checked = !checkAll;
    });
    setRecords(temp);
  };

  return (
    <>
      <div id="parent-printable">
        <div id="shelf-printable">
          {records.map((value) => (
            <>
              {value.is_checked && (
                <div
                  className="p-3 mt-3 rounded border-black text-center"
                  style={{ maxWidth: "58mm" }}
                >
                  <div
                    className="d-flex mt-3"
                    style={{
                      height: "30mm",
                      margin: 0,
                    }}
                  >
                    {/* <p style={{ transform: "rotate(90deg)" }}>
                          {value.name}
                        </p> */}
                    <h5
                      className="font-weight-bold"
                      style={{
                        flex: 1,
                        position: "static",
                        textAlign: "center",
                        transformOrigin: "center",
                        transform: "rotate(90deg)",
                      }}
                    >
                      {value.shelf_code.substring(0, 6) + `\n`}

                      <p style={{ fontSize: 10 }}>{value?.storage?.name}</p>
                    </h5>

                    <div
                      style={{
                        flex: 1.5,
                        position: "static",
                        transformOrigin: "center",
                        transform: "rotate(90deg)",
                      }}
                    >
                      <img
                        src="/images/degadai-logo.png"
                        alt="Degadai Logo"
                        style={{ width: "40mm" }}
                      />
                    </div>
                  </div>
                  <div className="h-100 d-flex align-items-center mt-5">
                    <QRCode value={value.shelf_code} size={170} />
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Daftar Shelf"} />
              <Breadcrumb current={"Shelf"} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{records.length}</span> Total
                Shelf
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 align-items-end">
            <div className="">
              Nama Shelf:
              <input
                type="text"
                className="form-control border-97A0AE"
                placeholder="Ketikan Nama Shelf"
                onChange={(e) => searchData(e.target.value)}
              />
            </div>

            <div className="ml-auto">
              <button
                className="ml-3 btn text-white font-weight-semi-bold"
                style={{ backgroundColor: "#F5CB58" }}
                onClick={() => setModalPrint(true)}
              >
                Cetak Label Shelf
              </button>
              <CanAccess
                role={AuthorizationList.create_shelf}
                yes={
                  <button
                    className="ml-3 btn bgc-2C465C text-white font-weight-semi-bold"
                    onClick={() => {
                      setModalAdd(true);
                      setIsEdit(false);
                    }}
                  >
                    + Tambah Shelf
                  </button>
                }
              />
            </div>
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(
                handleEdit,
                handleDelete,
                onCheck,
                checkAll,
                onCheckAll
              )}
              data={records}
              loading={loading}
              // handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={`${isEdit ? "Ubah" : "Tambah"} Shelf`}
        visible={modalAdd}
        onOk={() => handleSubmit(isEdit ? id : null)}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={() => handleSubmit(isEdit ? id : null)}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Pilih Storage :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Select
              options={storageList}
              onChange={(e) => setStorageId(e.value)}
              value={
                storageList.find((value) => value.value === storageId) || ""
              }
            />
          </div>
        </div>
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Shelf :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Nama Shelf"
              value={shelfName}
              onChange={(e) => setShelfName(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Kode Shelf :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Kode Shelf"
              value={shelfCode}
              onChange={(e) => setShelfCode(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Maks Barang :</div>
          </div>
          <div className="d-flex align-items-center" style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="number"
              className="form-control border-DCDCDC text-input"
              placeholder="Maks Barang"
              value={maxItem}
              onChange={(e) => setMaxItem(e.target.value)}
            />
            <div className="color-A6A6A6 ml-1">Barang</div>
          </div>
        </div>
        <div className="d-flex align-items-center mt-2">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Kategory Produk :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Select
              options={productCategoryList}
              onChange={(e) => setProductCategoryId(e.value)}
              value={
                productCategoryList.find(
                  (value) => value.value === productCategoryId
                ) || ""
              }
            />
          </div>
        </div>
      </Modal>
      <Modal
        className="modal-print"
        centered
        title={"Cetak Label Shelf"}
        visible={modalPrint}
        onCancel={() => setModalPrint(false)}
        footer={[
          <Button
            onClick={() => setModalPrint(false)}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={() => window.print()}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Cetak Label
          </Button>,
        ]}
      >
        <p className="mt-2 mb-0 text-center">
          Pastikan komputer Anda sudah terhubung dengan printer untuk mencetak
          label.
        </p>
      </Modal>
    </>
  );
};

export default ListShelf;
